import {
  GET_ROLE_MANAGEMENT_ROLES,
  GET_ROLE_MANAGEMENT_USERS,
  UPDATE_ROLE_MANAGEMENT_USER,
} from "@/api/users/users";

const state = {
  users: [],
  roles: [],
  isLoading: false,
  isSaving: false,
  totalItems: 0,
  page: 1,
  limit: 10,
  totalPages: 1,
};

const getters = {
  users: (state) => state.users,
  roles: (state) => state.roles,
  isLoading: (state) => state.isLoading,
  isSaving: (state) => state.isSaving,
  totalItems: (state) => state.totalItems,
  page: (state) => state.page,
  limit: (state) => state.limit,
  totalPages: (state) => state.totalPages,
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_SAVING(state, payload) {
    state.isSaving = payload;
  },
  SET_USERS(state, payload) {
    const data = payload || {};
    state.users = Array.isArray(data.data) ? data.data : [];
    state.totalItems = data.totalItems || 0;
    state.page = data.page || 1;
    state.limit = data.limit || 10;
    state.totalPages = data.totalPages || 1;
  },
  SET_ROLES(state, payload) {
    state.roles = Array.isArray(payload) ? payload : [];
  },
};

const actions = {
  async getUsers({ commit }, params = {}) {
    commit("SET_LOADING", true);
    try {
      const response = await GET_ROLE_MANAGEMENT_USERS(params);
      if (response.data.httpCode === 200) {
        commit("SET_USERS", response.data.data);
      }
      return response.data;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async getRoles({ commit }) {
    const response = await GET_ROLE_MANAGEMENT_ROLES();
    if (response.data.httpCode === 200) {
      commit("SET_ROLES", response.data.data);
    }
    return response.data;
  },

  async updateUserRole({ commit }, payload) {
    commit("SET_SAVING", true);
    try {
      const response = await UPDATE_ROLE_MANAGEMENT_USER(payload);
      return response.data;
    } finally {
      commit("SET_SAVING", false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
